"use client";

import { Header } from "./common/Header/Header";
import { Sidebar } from "./common/Sidebar/Sidebar";
import { SidebarMobile } from "./common/SidebarMobile/SidebarMobile";
import { SimpleSocketProvider } from "@/features/common/socket";
import { AnimatedOutlet } from "@/core/router/AnimatedOutlet";
import { useMediaQuery } from "usehooks-ts";
import { cn } from "@cronika/ui";

export const BaseLayout = () => {
  const isHorizontal = useMediaQuery("(max-height: 390px)");
  return (
    <SimpleSocketProvider>
      <div className="relative h-full w-full flex flex-col overflow-hidden bg-[#0C0C0C]">
        <div
          className="pointer-events-none absolute -bottom-50 -left-75 w-[400px] h-[400px] rounded-full opacity-60 blur-[100px] hidden lg:block"
          style={{
            background: "radial-gradient(47.58% 56.65% at 47.64% 51.63%, #F89A09 0%, #FEC201 100%)",
          }}
        />

        <div
          className="pointer-events-none absolute -top-100 right-1 w-[500px] h-[400px] rounded-full opacity-60 blur-[100px] hidden lg:block"
          style={{
            background: "radial-gradient(47.58% 56.65% at 47.64% 51.63%, #F89A09 0%, #FEC201 100%)",
          }}
        />

        <div className="flex flex-1 min-h-0 w-full z-10">
          <Sidebar />

          <div className={cn("hidden lg:hidden w-18 shrink-0 h-full", isHorizontal && "flex")}>
            <SidebarMobile />
          </div>

          <div className="flex flex-col flex-1 min-w-0 z-10">
            <Header />
            <div className="flex-1 min-h-0 overflow-hidden">
              <AnimatedOutlet />
            </div>
          </div>
        </div>

        {!isHorizontal && (
          <div className="absolute bottom-0 left-0 right-0 z-40 lg:hidden px-2 mb-2">
            <SidebarMobile />
          </div>
        )}
      </div>
    </SimpleSocketProvider>
  );
};
